module.exports = __webpack_public_path__ + "static/banner-metalprint-2-a64abd57dbb0bb2521389c4b906003ab.png";